import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import PersonIcon from '@mui/icons-material/Person'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import RepeatIcon from '@mui/icons-material/Repeat'

// Filter "type" presets for the report filter UI. Each preset is a FRONTEND-ONLY combination that
// fixes the canonical (type, partition) pair the backend understands:
//   - type      : which table the predicate field is read from ('payment' | 'contact')
//   - partition : the grain the existence test runs at ('payment' = row-level | 'order' | 'contact')
//
// The preset `id` is a UI concept only — it NEVER crosses the wire and is NEVER persisted. Segments
// store the canonical `type` + `partition`; the chip reconstructs the label from them for display.
// This forward map (preset -> canonical) and the reverse lookups below are the single source of
// truth shared by AddFilterPopover (build) and ContextChipFilter (display).
export const DEFAULT_FILTER_PARTITION = 'payment'

export const FILTER_TYPE_PRESETS = [
  { id: 'payment',  label: 'Sale Data',      typeId: 'payment', partition: 'payment', Icon: AttachMoneyIcon },
  { id: 'contact',  label: 'Contact Source', typeId: 'contact', partition: 'payment', Icon: PersonIcon },
  { id: 'order',    label: 'Order Contains', typeId: 'payment', partition: 'order',   Icon: ShoppingCartIcon },
  { id: 'customer', label: 'Customer Ever',  typeId: 'payment', partition: 'contact', Icon: RepeatIcon },
]

// Canonical field-source display name (filter.type.name), keyed by canonical type id. Kept stable and
// independent of the UI preset label so a persisted filter never embeds a UI abstraction.
export const FILTER_TYPE_NAMES = {
  payment: 'Sale Data',
  contact: 'Contact Source',
}

// Canonical (type, partition) -> preset. `partition` defaults to 'payment' for pre-partition filters.
// Returns undefined for a combination no preset produces (only reachable from stale/corrupt stored
// data — the UI only ever emits the four presets, and the backend rejects unsupported combos);
// callers editing a stored filter fall back to the default preset rather than crash.
export const getFilterPresetByCanonical = (typeId, partition) =>
  FILTER_TYPE_PRESETS.find(preset => preset.typeId === typeId && preset.partition === (partition || DEFAULT_FILTER_PARTITION))
